import { render, staticRenderFns } from "./serviceFee.vue?vue&type=template&id=601da6a6"
import script from "./serviceFee.vue?vue&type=script&lang=js"
export * from "./serviceFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports